<template>
  <div class="user-detail-wrapper">
    <div class="user-control">
      <el-checkbox
        v-if="checkPermission(['USER_ADMIN'])"
        size="small"
        style="margin-right: 10px"
        :disabled="isSetting"
        v-model="userDetail.enable"
        :label="userDetail.enable ? '已启用' : '已禁用'"
        border
        @change="onUserStatusChange"
      ></el-checkbox>

      <el-button
        :disabled="isSetting"
        size="small"
        type="danger"
        v-if="checkPermission(['USER_ADMIN'])"
        @click="onUserDelete"
        >删除</el-button
      >

      <div class="edit-user-passwrd" v-if="isSetPassword">
        <el-input
          style="width: 250px; margin-right: 10px"
          size="small"
          placeholder="请输入新密码"
          v-model.trim="newPassword"
        ></el-input>
        <div class="control-group">
          <el-button
            :loading="isSetting"
            type="success"
            size="mini"
            icon="el-icon-check"
            @click="onConfirmNewPassword"
            >{{ isSetting ? "设置中" : "" }}</el-button
          >
          <el-button
            :disabled="isSetting"
            type="danger"
            style="background-color: #f56c6c"
            size="mini"
            icon="el-icon-close"
            @click="isSetPassword = false"
          ></el-button>
        </div>
      </div>

      <el-button
        :disabled="isSetting"
        size="small"
        v-if="!isSetPassword && checkPermission(['USER_ADMIN'])"
        @click="isSetPassword = true"
        >修改密码</el-button
      >

      <el-button
        :disabled="isSetting"
        size="small"
        type="danger"
        v-if="userDetail.weChatMpBound"
        @click="unBoundWechat"
        >解绑微信</el-button
      >
    </div>
    <el-form
      :loading="loading"
      :model="userDetail"
      label-position="left"
      status-icon
      ref="ruleForm"
      class="user-form"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="客户名称:" prop="name">
            <span>{{ userDetail.name }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建时间:" prop="createdAt">
            <span>{{ userDetail.createdAt | date }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建人:" prop="creatorName">
            <span>{{ userDetail.creatorName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="账号状态:" prop="disabled">
            <span class="text-info" v-if="userDetail.disabled">
              <i class="el-icon-circle-close"></i> 禁用
            </span>
            <span class="text-success" v-if="!userDetail.disabled">
              <i class="el-icon-circle-check"></i> 启用
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户账号:" prop="id">
            <span>{{ userDetail.id }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户姓名:" prop="name">
            <span>{{ userDetail.name }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属部门:" prop="departmentName">
            <span>{{ userDetail.departmentName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="更新人:" prop="updaterName">
            <span>{{ userDetail.updaterName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="更新时间:" prop="updatedAt">
            <span>{{ userDetail.updatedAt | date }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公众号绑定:" prop="weChatMpBound">
            <span>{{ userDetail.weChatMpBound ? "已绑定" : "未绑定" }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否在招商筛选中显示:" prop="showInMerchantFilter">
            <span :class="[ userDetail.showInMerchantFilter ? 'text-success' : '']">{{ userDetail.showInMerchantFilter ? "显示" : "隐藏" }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="userDetail.weChatMpBound">
          <el-form-item label="微信昵称:" prop="nickNameWeChat">
            <span>{{ userDetail.nickNameWeChat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="用户角色:" prop="roles">
            <el-tag
              style="margin: 0 10px"
              type="success"
              v-for="item in userDetail.roleNames"
              :key="item"
              >{{ item }}</el-tag
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { checkPermission } from "@/utils/auth";
export default {
  props: {
    userId: {
      type: [String, Array],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      isSetting: false,
      isSetPassword: false,
      newPassword: "",
      rolesOptions: [],
      userDetail: {},
    };
  },
  created() {
    this.getRolesOptions().then(() => {
      if (this.userId !== "") {
        this.getUserDetail(this.userId);
      }
    });
  },
  methods: {
    checkPermission,
    getUserDetail(id) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.$api
          .get(`/users/${id}`)
          .then((res) => {
            if (res.status === 200) {
              let roleNames = [];
              if (this.rolesOptions.length > 0) {
                res.data.roles.forEach((element) => {
                  let taraget = this.rolesOptions.find(
                    (ele) => ele.id === element
                  );
                  if (taraget) {
                    roleNames.push(taraget.name);
                  }
                });
              }
              this.userDetail = res.data;
              this.userDetail.enable = !res.data.disabled;
              this.userDetail.roleNames = roleNames;
              this.loading = false;
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
            this.loading = false;
            console.log(err.response);
            this.$message.error(err.response.data.message);
          });
      });
    },
    onUserStatusChange(val) {
      this.isSetting = true;
      this.$api
        .put(`/users/${this.userId}/usability/switch`)
        .then((res) => {
          if (res.status === 201 || res.status === 204) {
            this.isSetting = false;
            this.$message.success("设置成功");
            this.getUserDetail(this.userId);
          } else {
            this.isSetting = false;
          }
        })
        .catch((err) => {
          this.isSetting = false;
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    // 确认设置新密码
    onConfirmNewPassword() {
      if (this.newPassword === "") {
        this.$message.error("密码不能为空");
        return false;
      }
      this.$api
        .put(`/users/${this.userId}/password/updating`, {
          newPassword: this.newPassword,
        })
        .then((res) => {
          if (res.status === 201 || res.status === 204) {
            this.isSetting = false;
            this.$message.success("设置成功");
            this.getUserDetail(this.userId);
          } else {
            this.isSetting = false;
          }
        })
        .catch((err) => {
          this.isSetting = false;
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    // 删除用户
    onUserDelete() {
      if (this.userId === "") {
        return false;
      }
      this.isSetting = true;
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .delete(`/users/${this.userId}`)
            .then((res) => {
              if (res.status === 204) {
                this.isSetting = false;
                this.$message.success("操作成功");
                this.$emit("deleteSuccess");
              } else {
                this.isSetting = false;
              }
            })
            .catch((err) => {
              this.isSetting = false;
              console.log(err.response);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {
          this.isSetting = false;
        });
    },
    // 解绑微信
    unBoundWechat() {
      if (this.userId === "") {
        return false;
      }
      this.isSetting = true;
      this.$confirm("是否需要解除该用户的公众号绑定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .put(`/users/${this.userId}/we_chat_mp/unbind`)
            .then((res) => {
              if (res.status === 201 || res.status === 204) {
                this.isSetting = false;
                this.$message.success("操作成功");
                this.$emit("unBoundSuccess");
              } else {
                this.isSetting = false;
              }
            })
            .catch((err) => {
              this.isSetting = false;
              console.log(err.response);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {
          this.isSetting = false;
        });
    },
    getRolesOptions() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(`/users/roles/selections`)
          .then((res) => {
            if (res.status === 200) {
              this.rolesOptions = res.data;
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject();
            console.log(err.response);
            this.$message.error(err.response.data.message);
          });
      });
    },
  },
  destroyed() {
    this.isSetPassword = false;
    this.isSetting = false;
  },
};
</script>

<style lang="scss" scoped>
.user-detail-wrapper {
  box-sizing: border-box;
  width: 100%;
  text-align: left;
  padding: 15px;
  .user-control {
    padding: 15px 0;
    text-align: right;
    display: flex;
    justify-content: flex-end;
  }
  .edit-user-passwrd {
    box-sizing: border-box;
    margin-right: 10px;
    margin-left: 10px;
    display: flex;
    justify-content: flex-end;
    .control-group {
      display: inline-block;
    }
  }
}
</style>